<div class="main">
    <div class="centerbox">
        <div class="l1">DLZP</div>
        <div class="l2">Content Management System</div>
        <div class="l3">v1.0.11</div>
    </div>
</div>

